import React, { useEffect, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { Translate } from "../../Enums/Tranlate";
import AdminService from "../../../services/AdminService";
import { useNavigate } from "react-router-dom";
import pin from "../../../images/icons/pin.svg";
import totalAdmins from "../../../images/icons/total-admins.svg";
import packages from "../../../images/icons/packages.svg";
import booking from "../../../images/icons/booking.svg";
import productsImg from "../../../images/icons/products.svg";
import matches from "../../../images/icons/matches.svg";
import category from "../../../images/icons/category.svg";
import users from "../../../images/icons/users.svg";
import "./style.scss";

const Dashboard = () => {
	const [formData, setFormData] = useState({
		user: "",
		category: "",
		product: "",
		pack: "",
		pinMark: "",
		publicMatch: "",
		privateMatch: "",
		tournamentMatch: "",
		booking: "",
		totalAdmins: "",
	});
	const [loading, setLoading] = useState(false);
	const lang = useSelector((state) => state.auth.lang);
	const navigate = useNavigate();

	useEffect(() => {
		setLoading(true);
		new AdminService()
			.getDashboard()
			.then((res) => {
				if (res?.status) {
					setFormData(res.data.data);
				}
				setLoading(false);
			})
			.catch(() => setLoading(false));
	}, []);

	if (loading) {
		return (
			<Row>
				{Object.entries(formData)?.map((_, index) => {
					return (
						<Col className="col-md-4 col-sm-6" key={index}>
							<Card style={{ height: "128.75px" }}>
								<Card.Body>
									<div className="skeleton-loader">
										<div className="loader-header"></div>
										<div className="loader-content"></div>
									</div>
								</Card.Body>
							</Card>
						</Col>
					);
				})}
			</Row>
		);
	}

	return (
		<div className="dashboard">
			<div className="dashboard-info">
				<div className="row">
					{/* Users */}
					<div className="col-md-3 mb-3 col-6">
						<div className="card" onClick={() => navigate("/users")}>
							<img src={users} alt="dollar" width={40} className="mb-2" />

							<span className="fs-16">{formData?.user}</span>
							<h2 className="fs-14 my-2">{Translate[lang].total_users}</h2>
						</div>
					</div>
					{/* Categories */}
					<div className="col-md-3 mb-3 col-6">
						<div className="card" onClick={() => navigate("/")}>
							<img src={category} alt="dollar" width={40} className="mb-2" />

							<span className="fs-16">{formData?.category}</span>
							<h2 className="fs-14 my-2">{Translate[lang].total_categories}</h2>
						</div>
					</div>
					{/* Products */}
					<div className="col-md-3 mb-3 col-6">
						<div className="card" onClick={() => navigate("/products")}>
							<img
								src={productsImg}
								alt="productsImg"
								width={40}
								className="mb-2"
							/>

							<span className="fs-16">{formData?.product}</span>
							<h2 className="fs-14 my-2">{Translate[lang].total_products}</h2>
						</div>
					</div>
					{/* Packages */}
					<div className="col-md-3 mb-3 col-6">
						<div className="card" onClick={() => navigate("/packages")}>
							<img src={packages} alt="dollar" width={40} className="mb-2" />

							<span className="fs-16">{formData?.pack}</span>
							<h2 className="fs-14 my-2">{Translate[lang].total_packages}</h2>
						</div>
					</div>
					{/* Pin Mark */}
					<div className="col-md-3 mb-3 col-6">
						<div className="card" onClick={() => navigate("/pin-market-place")}>
							<img src={pin} alt="dollar" width={40} className="mb-2" />

							<span className="fs-16">{formData?.pinMark}</span>
							<h2 className="fs-14 my-2">{Translate[lang].pinMark}</h2>
						</div>
					</div>
					{/* Public */}
					<div className="col-md-3 mb-3 col-6">
						<div className="card" onClick={() => navigate("/matches")}>
							<img src={matches} alt="dollar" width={40} className="mb-2" />

							<span className="fs-16">{formData?.publicMatch}</span>
							<h2 className="fs-14 my-2">
								{Translate[lang].total_matches}({Translate[lang].public})
							</h2>
						</div>
					</div>
					{/* Private */}
					<div className="col-md-3 mb-3 col-6">
						<div className="card" onClick={() => navigate("/matches")}>
							<img src={matches} alt="dollar" width={40} className="mb-2" />

							<span className="fs-16">{formData?.privateMatch}</span>
							<h2 className="fs-14 my-2">
								{Translate[lang].total_matches}({Translate[lang].private})
							</h2>
						</div>
					</div>
					{/* Tournament */}
					<div className="col-md-3 mb-3 col-6">
						<div className="card" onClick={() => navigate("/matches")}>
							<img src={matches} alt="dollar" width={40} className="mb-2" />

							<span className="fs-16">{formData?.tournamentMatch}</span>
							<h2 className="fs-14 my-2">
								{Translate[lang].total_matches}({Translate[lang].tournament})
							</h2>
						</div>
					</div>
					{/* Booking */}
					<div className="col-md-3 mb-3 col-6">
						<div className="card" onClick={() => navigate("/all-booking")}>
							<img src={booking} alt="dollar" width={40} className="mb-2" />

							<span className="fs-16">{formData?.booking}</span>
							<h2 className="fs-14 my-2">{Translate[lang].booking}</h2>
						</div>
					</div>
					{/* Admins */}
					<div className="col-md-3 mb-3 col-6">
						<div className="card" onClick={() => navigate("/admins")}>
							<img src={totalAdmins} alt="dollar" width={40} className="mb-2" />

							<span className="fs-16">{formData?.user}</span>
							<h2 className="fs-14 my-2">{Translate[lang].admins}</h2>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Dashboard;
